import './handlebar-helpers';
import { ArticleQuestionnaire } from './questionnaire';

export default ArticleQuestionnaire;